<template>
  <!-- Só a régua vai aqui: o nome já vem nas props que o autocomplete entrega ao item (e que caem no
       `v-list-item` pela herança de atributos), e escrevê-lo de novo mostraria a opção duas vezes. -->
  <v-list-item ripple>
    <template #prepend>
      <ontos-color-accent vertical :color="optionColorOf(item)" class="ontos-rel-accent-list"/>
    </template>
  </v-list-item>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import ColorAccent from '@/components/shared/ColorAccent.vue'
import {optionColorOf} from '@/utils/propertyDisplay'

/**
 * Uma opção da lista de um campo de relacionamento, com a régua da cor do item: escolher na lista
 * passa a ser reconhecer a cor que se vê no card, na linha e na ficha.
 *
 * Para o slot `#item` do autocomplete, com as props dele: `<ontos-rel-option v-bind="props"
 * :item="item"/>`. Estava escrito no campo de relacionamento, no reverso e na janela de vincular.
 */
@Component({name: 'ontos-rel-option', components: {'ontos-color-accent': ColorAccent}})
class RelOption extends Vue {
  @Prop({required: true}) readonly item!: any
  //exposta ao template: função de módulo não é enxergada de lá
  optionColorOf = optionColorOf
}

export default toNative(RelOption)
</script>
